import { render, staticRenderFns } from "./Carregando.vue?vue&type=template&id=351c3be2&"
import script from "./Carregando.vue?vue&type=script&lang=js&"
export * from "./Carregando.vue?vue&type=script&lang=js&"
import style0 from "./Carregando.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports